var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("shinabitanori-gallery")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('vue-masonry-gallery',{attrs:{"imgsArr":_vm.media,"random":true,"target":_vm.blank,"perPage":18,"maxCols":6,"loadingTimeOut":100}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("小峰さちこ｜shinabitanoriの短歌などの画像")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78230455","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 15
// module chunks = 0